module.exports = __webpack_public_path__ + "static/media/Kaitlyn_Kang.ec010688.png";